import type { MouseEvent } from "react";

export type LeadWhatsappIntencao = "demo" | "contato";

export type LeadWhatsappPedido = {
  /** Onde o CTA foi clicado (ex.: `home_hero`, `cta_eventos`). */
  contexto: string;
  intencao: LeadWhatsappIntencao;
};

type Listener = () => void;

let pedidoAtual: LeadWhatsappPedido | null = null;
const listeners = new Set<Listener>();

function emitir() {
  for (const l of listeners) l();
}

export const leadWhatsappStore = {
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot: () => pedidoAtual,
  abrir(pedido: LeadWhatsappPedido) {
    pedidoAtual = pedido;
    emitir();
  },
  fechar() {
    pedidoAtual = null;
    emitir();
  },
};

/**
 * `onClick` para CTAs de WhatsApp comercial: abre o formulário de lead antes do WhatsApp.
 * Ctrl/Cmd/Shift+clique e botão do meio seguem o `href` original.
 */
export function abrirLeadWhatsappOnClick(pedido: LeadWhatsappPedido) {
  return (e: MouseEvent<HTMLElement>) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    leadWhatsappStore.abrir(pedido);
  };
}
